import { render, staticRenderFns } from "./lin-search.vue?vue&type=template&id=6145e8a6&scoped=true"
import script from "./lin-search.vue?vue&type=script&lang=js"
export * from "./lin-search.vue?vue&type=script&lang=js"
import style0 from "./lin-search.vue?vue&type=style&index=0&id=6145e8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145e8a6",
  null
  
)

export default component.exports